import { inject } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

export abstract class AbstractModalComponent<TComponentData extends object> {
    public readonly componentData: TComponentData = inject(NZ_MODAL_DATA);
}
